/* Review quotes: clamp to three lines and add "Read more" when the quote is longer.
   Mark a quote with data-sd-clamp; words come from data-more / data-less. */
import { t as T } from '@sunday/text';

const run = () => {
  // read, then write, then read once more: one layout pass for all quotes, not one per quote
  const qs = [...document.querySelectorAll('[data-sd-clamp]:not([data-sd-clamp-on])')].filter((q) => q.getClientRects().length);
  qs.forEach((q) => { q.setAttribute('data-sd-clamp-on', ''); q.classList.add('is-clamped'); });
  const long = qs.map((q) => q.scrollHeight > q.clientHeight + 2);
  qs.forEach((q, i) => {
    if (!long[i]) { q.classList.remove('is-clamped'); return; }
    const b = document.createElement('button');
    b.type = 'button'; b.className = 'sd-clamp-more';
    b.textContent = q.dataset.more || T('common.read_more');
    b.setAttribute('aria-expanded', 'false');
    b.addEventListener('click', () => {
      const open = q.classList.toggle('is-clamped') === false;
      b.textContent = open ? (q.dataset.less || T('common.show_less')) : (q.dataset.more || T('common.read_more'));
      b.setAttribute('aria-expanded', String(open));
    });
    q.insertAdjacentElement('afterend', b);
  });
};
run();
document.addEventListener('shopify:section:load', run);
document.addEventListener('sunday:clamp', run);
